const appConstants = {
  version: "0.55.3",
  defaultAlertDuration: 3000, // miliseconds
  defaultAlertPosition: "top-right",
};

const alertMap = {
  success: 'success',
  error: 'danger',
  warning: 'warning',
  info: 'info',
};
const alertMessages = {
  noLeaveAvailable: 'No leave balance available',
};

const fullMonths = [
  { name: "January - December", number: "1/12" },
  { name: "February - January", number: "2/1" },
  { name: "March - February", number: "3/2" },
  { name: "April - March", number: "4/3" },
  { name: "May - April", number: "5/4" },
  { name: "June - May", number: "6/5" },
  { name: "July - June", number: "7/6" },
  { name: "August - July", number: "8/7" },
  { name: "September - August", number: "9/8" },
  { name: "October - September", number: "10/9" },
  { name: "November - October", number: "11/10" },
  { name: "December - November", number: "12/1" },
];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const dashboardTotalAttendanceStatus = [
  {
    id: '1',
    icon: 'images/totalattendance-icon.svg',
    iconWidth: '40',
    backgroundImg: 'images/totalattendance.svg',
    backgroundImgWidth: '95',
    name: 'Total Attendance',
    count: '0',
  },
  {
    id: '2',
    icon: 'images/totalleaves-icon.svg',
    iconWidth: '40',
    backgroundImg: 'images/totalleaves.svg',
    backgroundImgWidth: '80',
    name: 'Total Leaves',
    count: '0',
  },
  {
    id: '3',
    icon: 'images/totalrequest-icon.svg',
    iconWidth: '40',
    backgroundImg: 'images/totalrequest.svg',
    backgroundImgWidth: '50',
    name: 'Total Request',
    count: '0',
  },
];
const dashboardWishesCard = [
  {
    title: 'Birthday Wishes',
    subTitle: '5 People have Birthday Today, send your best wishes to them',
    btnText: ' Send Wishes',
    lottieImageSrc: 'images/birthday-candles.json',
    lottieCustomeStyle: { width: "100px" },
  },
  {
    title: 'Kudos',
    subTitle: '5 People received KUDOS for their expceptional Performancem',
    btnText: 'View',
    lottieImageSrc: 'images/well-done.json',
    lottieCustomeStyle: { width: "110px", bottom: "10px" },
  },
  {
    title: 'Anniversary Today',
    subTitle: '5 People have One year Anniversary Today Congratulate them',
    btnText: 'Send Wishes',
    lottieImageSrc: 'images/first-anniversary-celebration.json',
    lottieCustomeStyle: { width: "90px" },
  },
  {
    title: 'Write a Post',
    subTitle: ' Share your thoughts, give wishes and know about your colleagues',
    btnText: 'Create a Post',
    lottieImageSrc: 'images/writepost.json',
    lottieCustomeStyle: { width: "90px" },
  }
]

const axiosConfig = {
  withCredentials: true
}
const pagination = {
  limit: 10,
  page: 1,
}
const workExperienceType = [{
  label: "Fresher", value: "fresher"
},
{ label: "Experience", value: "experience" }
]
const financialYearDuration = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Half Yearly", value: "half_yearly" },
  { label: "Yearly", value: "yearly" }
]
const KRARatingType = [
  { label: "Rating", value: "rating" },
  { label: "Target Achievement", value: "target_achievement" },

]
const qualityOptions = [
  { label: "Need Improvement", value: "need_improvement" },
  { label: "Satisfactory", value: "satisfactory" },
  { label: "Good", value: "good" },
  { label: "Excellent", value: "Excellent" }
];

const yesNoOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
]
const yesNoFlexOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'flexible', label: 'Flexible ' },
];

const deductionTypeOptions = [
  { value: 'employee', label: 'Employee Contribution' },
  { value: 'employer', label: 'Employer Contribution' },
  { value: 'other', label: 'Other Deduction' },

];

const emailOptions = [
  { value: 'personal_email', label: 'Personal Email' },
  { value: 'official_email', label: 'Official Email' }
]

const deductionFrequency = [
  { value: 'One-time deduction', label: 'One-time deduction' },
  { value: 'Recurring deduction for subsequent Payrolls', label: 'Recurring deduction for subsequent Payrolls' },
];

const calculationTypeOptions = [
  { value: 'fixed', label: 'Fixed' },
  { value: 'percentage', label: 'Percentage' },
  { value: 'flexible_amount', label: 'Flexible Amount' },
  // { value: 'slab_wise', label: 'Slab Wise' },
];

const attendanceReportType = [
  { value: 'detailed_report', label: 'Detailed Report' },
  { value: 'muster_roll_report', label: 'Muster Roll Report' },
];

const creditDebitLeave = [
  { value: 'CR', label: 'Credit (+CR)' },
  { value: 'DR', label: 'debit (+DR)' },
]

const giveFeedbackOption = [
  { value: 'general', label: 'General' },
  { value: 'kpi_wise', label: 'KPI Wise' },
]

const addKudosCategory = [
  { value: 'point', label: 'Point' },
  { value: 'vouchers', label: 'Vouchers' },
]

const audienceData = [
  { value: 'department', label: 'Department' },
  { value: 'roles', label: 'Roles' },
  { value: 'employee', label: 'Employee' },
  { value: 'branch', label: 'Branch' }
]

const assetCategory = [
  { value: "Custom", label: "Custom" },
  { value: "Laptop", label: "Laptop" },
  { value: "Mobile", label: "Mobile" },
  { value: " ID Card", label: " ID Card" },
  { value: "Other", label: " Other" },

]

const assetType = [
  { value: "Custom", label: "Custom" },
  { value: "iPhone 14 Pro", label: "iPhone 14 Pro" },
  { value: "Dell OptiPlex 7000", label: " Dell OptiPlex 7000" },
  { value: "Motorola", label: " Motorola" },
   { value: "Desktop", label: " Desktop" },
      { value: "Laptop", label: " Laptop" },
  { value: "Other", label: " Other" },


]
const currentCondition = [
  { value: "New", label: "New" },
  { value: "Good", label: "Good" },
  { value: "Fair", label: "Fair" },
  { value: "Damaged", label: "Damaged" },
  { value: "Other", label: "Other" },


]
const assetsStatus = [
  { value: "Available", label: "Available" },
  { value: "Assigned", label: "Assigned" },
  { value: "Under Maintenance", label: "Under Maintenance" },
  { value: "Retired", label: "Retired" },
  { value: "Lost", label: "Lost" },
  { value: "Other", label: "Other" },
]

const deductionSource = [
  { value: "Manual", label: "Manual" },
  { value: "Salary", label: "Salary" },
]
const recoveryStatus = [
  { value: "Ongoing", label: "Ongoing" },
  { value: "Completed", label: "Completed" },
  { value: "Stopped", label: "Stopped" },
]
const assetProcess = [
  { value: "New", label: "New" },
  { value: "Replacement", label: "Replacement" },

]
const assetPriority = [
  { value: "Low", label: "Low" },
  { value: "Normal", label: "Normal" },
]
const ticketIssueStatus = [
  { value: "type", label: "Type" },
  { value: "sub_type", label: "Sub Type" },
]
const replacementData = [
  { value: "Lenovo Laptop", label: "Lenovo Laptop" },


]

const moodRatingKeyword =["Ignored","Frustrated","Tensed","At Ease","Cheerful","Enthusiastic"]

const adminLeaveBgClasses = ["bg-navy-blue", "bg-warning", "bg-buety-green"];


export default appConstants;
export {
  alertMessages,
  fullMonths,
  months,
  weekDays,
  dashboardWishesCard,
  dashboardTotalAttendanceStatus,
  axiosConfig,
  pagination,
  workExperienceType,
  financialYearDuration,
  KRARatingType,
  qualityOptions,
  yesNoOptions,
  yesNoFlexOptions,
  deductionFrequency,
  calculationTypeOptions,
  attendanceReportType,
  creditDebitLeave,
  giveFeedbackOption,
  addKudosCategory,
  emailOptions,
  audienceData,
  assetType,
  assetCategory,
  currentCondition,
  assetsStatus,
  deductionSource,
  recoveryStatus,
  assetProcess,
  assetPriority,
  replacementData,
  ticketIssueStatus,
  moodRatingKeyword,
  adminLeaveBgClasses,
  alertMap,
  deductionTypeOptions
};